var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide gallery",style:(_vm.slide.backgroundColor
      ? `background-color: ${_vm.slide.backgroundColor};`
      : 'transparent;')},[(_vm.isLoading)?_c('Loading'):_vm._e(),(_vm.slide.photo)?_c('div',{staticClass:"bg-full",style:(`background-image: url(${_vm.slide.photo})`)}):_vm._e(),_c('vue-justified-layout',{ref:"grid",staticClass:"center-img",attrs:{"items":_vm.items,"options":{
      targetRowHeight: _vm.rowHeight,
      showWidows: true,
      boxSpacing: 1,
      containerPadding: 10,
      forceAspectRatio: false,
    }},scopedSlots:_vm._u([{key:"default",fn:function({ item, style, index }){return [_c('img',{attrs:{"src":item.thumb},on:{"click":function($event){return _vm.openLightbox(index)},"load":_vm.onImgLoad}})]}}])}),_c('app-footer',{attrs:{"footer":_vm.slide.footnote,"details":_vm.slide.details,"position":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }